import React, { useMemo } from 'react';

const MapLegend = ({ label, data }) => {
  // Get the field names mapping
  const fieldLabels = {
    average_score: 'Avg. policy score',
    number_of_policies: 'No. of policies',
    average_month_duration: 'Time duration in months'
  };

  // Generate dynamic legend items based on actual data
  const legendItems = useMemo(() => {
    if (!data || !label) return [];
    
    // Extract values for the current data field
    const values = data[label] ? data[label].filter(value => value !== undefined && value !== null) : [];
    
    if (values.length === 0) return [];
    
    // Get min and max values
    const min = Math.min(...values);
    const max = Math.max(...values);
    
    // For cases like "policies" where we want clear integer boundaries
    const colors = ['#F2B33D', '#F29727', '#F2811D', '#A64005', '#401201'];
    // For other metrics, create ranges based on the data but with clear boundaries
    const step = Math.ceil((max - min) / 5); // Round up to ensure we cover the full range
      
    // Create legend items with non-overlapping ranges
    return Array.from({ length: 5 }).map((_, index) => {
      const lowerBound = min + (step * index);
      const upperBound = index === 4 ? max : min + (step * (index + 1)) - 1;
      
      // Format the range text with whole numbers
      let rangeText;
      if (index === 4) {
        rangeText = `${Math.floor(lowerBound)}+`;
      } else {
        rangeText = `${Math.floor(lowerBound)} - ${Math.floor(upperBound)}`;
      }
    
      return {
        range: rangeText,
        color: colors[index]
      };
    }).reverse(); // Reverse to have darkest color at the top
  }, [data]);

  // Handle case where there's no data
  if (!legendItems.length) {
    return <div className="flex flex-col items-center text-nowrap">No data available</div>;
  }

  return (
    <div className="flex flex-col items-center text-nowrap">
      <h3 className="font-semibold mb-2">{fieldLabels[label] || label}</h3>
      <div className="flex flex-col">
        {legendItems.map((item, index) => (
          <div key={index} className="flex items-center mb-1">
            <div 
              className="w-4 h-4 mr-2" 
              style={{ backgroundColor: item.color }}
            />
            <span>{item.range}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MapLegend;